var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"three-box"},[_c('img',{staticClass:"bg",attrs:{"src":require("../../assets/images/display_bg.png")}}),_c('pullDown',{attrs:{"width":110,"height":150,"title":'户型详情',"url":require('../../assets/images/pullMsg.png'),"top":"13%","right":"1%"}}),_vm._m(0),_c('div',{staticClass:"back-icon",on:{"click":_vm.backSelect}},[_c('img',{attrs:{"src":require("@/assets/Back.svg"),"alt":"","srcset":""}})]),_c('div',{staticClass:"house-show"},[_c('model-gltf',{ref:"model",attrs:{"src":"/A1.gltf","width":898,"height":414,"backgroundColor":'rbg(0,0,0)',"backgroundAlpha":0,"lights":[
          {
            type: 'DirectionalLight',
            position: { x: 1, y: 1, z: 1 },
            color: 0xffffff,
            intensity: 0.8,
          },
          {
            type: 'DirectionalLight',
            position: { x: -1, y: 1, z: 1 },
            color: 0xffffff,
            intensity: 0.8,
          },
          {
            type: 'DirectionalLight',
            position: { x: 1, y: 1, z: -1 },
            color: 0xffffff,
            intensity: 0.8,
          },
          {
            type: 'DirectionalLight',
            position: { x: -1, y: 1, z: -1 },
            color: 0xffffff,
            intensity: 0.8,
          },
          {
            type: 'DirectionalLight',
            position: { x: 0, y: -1, z: 0 },
            color: 0xffffff,
            intensity: 0.8,
          } 
      ],"id":"test","rotation":_vm.rotation,"cameraRotation":_vm.cameraRotation},on:{"on-mousemove":_vm.clickObj}})],1)],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"house-title"},[_c('img',{attrs:{"src":"https://images.jianshankeji.com/timepark_select_housetitle.svg"}})])}]

export { render, staticRenderFns }